import { Brief, BriefSection, DynamicSection, SectionTypes } from '@fiverr-private/ai_brief';
import { appTranslate } from '../../../i18n';
import { EditScreeningQuestions, ViewScreeningQuestions } from './components';
import type { ScreeningQuestionsContent } from './utils/types';
import { SECTION_ID } from './utils/constants';

export const screeningQuestionsSectionID = SECTION_ID;

export const getScreeningQuestionsSection = (brief: Brief<ScreeningQuestionsContent>): DynamicSection => {
    const existingSection = brief.sections.find((section) => section.id === screeningQuestionsSectionID);
    const hasExistingQuestions = Boolean(existingSection?.content?.questions?.length);
    const content = hasExistingQuestions ? existingSection!.content : { questions: [] };

    return {
        id: screeningQuestionsSectionID,
        title: appTranslate<string>('sections.screening_questions.title'),
        content,
        included: hasExistingQuestions,
        type: SectionTypes.dynamic,
        hideActions: true,
        focused: false,
        customValidator: (section: BriefSection<ScreeningQuestionsContent>) =>
            Boolean(section?.content?.questions?.length),
        ViewComponent: ViewScreeningQuestions,
        EditComponent: EditScreeningQuestions,
    };
};

export * from './components';
export * from './utils/types';
export * from './utils/constants';
